import React from 'react';
import ImageBlock from '../platformui/ImageBlock';
import * as Render from '../platformui/Base/Render';
import withSrcSets from '../platformui/Containers/withSrcSets';
import withLazyLoad from '../platformui/Containers/withLazyLoad';

const ImageBlockWithSrcSets = withLazyLoad(withSrcSets(ImageBlock));
export default (props) => (
  <ImageBlockWithSrcSets
    {...props}
    ImageText={Render.Property(props.ImageText, 'ImageText')}
  />
);
